<script setup lang="ts">
    import Modal, { ModalSize } from './Modal.vue';
    import { __ } from '../stores/expressions';
    import EchoButton from './EchoButton.vue';
    import { useConfirmationDialog } from '../stores/confirmationDialog';
    import { CheckIcon, XIcon } from '@lucide/vue';

    const confirmationDialogStore = useConfirmationDialog();
</script>
<template>
    <Modal
        :show="confirmationDialogStore.open"
        :size="ModalSize.Medium"
        layer="confirm"
        @close="confirmationDialogStore.cancel"
    >
        <div>
            <h1
                v-if="confirmationDialogStore.dialogConfig.title"
                class="text-xl font-semibold mb-4"
            >
                {{ confirmationDialogStore.dialogConfig.title }}
            </h1>
            <p class="text-base mb-8">
                {{ confirmationDialogStore.dialogConfig.message }}
            </p>
            <div class="flex justify-end gap-2">
                <EchoButton
                    :loading="confirmationDialogStore.loading"
                    @click="confirmationDialogStore.cancel"
                >
                    {{ confirmationDialogStore.dialogConfig.cancelText ?? __('cancel') }}
                    <template #icon-right>
                        <component :is="confirmationDialogStore.dialogConfig.cancelIcon ?? XIcon" />
                    </template>
                </EchoButton>
                <EchoButton
                    variant="primary"
                    :loading="confirmationDialogStore.loading"
                    @click="confirmationDialogStore.confirm"
                >
                    {{ confirmationDialogStore.dialogConfig.confirmText ?? __('confirm') }}
                    <template #icon-right>
                        <component
                            :is="confirmationDialogStore.dialogConfig.confirmIcon ?? CheckIcon"
                        />
                    </template>
                </EchoButton>
            </div>
        </div>
    </Modal>
</template>
